import "./aarchmerchanttool.scss";
import "../../src-utilities/footer";
import "../../src-utilities/header";
document.addEventListener("DOMContentLoaded", function () {
  var image = document.querySelector(".youtubeimg");
  var videoFrame = document.getElementById("youtubevideoid");

  if (image) {
    image.addEventListener("click", function () {
      this.style.display = "none";
      videoFrame.style.display = "block";
      videoFrame.src =
        "https://www.youtube.com/embed/qtmJBG4cjXE?si=1VwMN4lXNakxKjjw?rel=0&autoplay=1";
    });
  }
});

function changeTab(a) {
  document
    .querySelectorAll(".content")
    .forEach((a) => a.classList.remove("active"));
  document.getElementById(`content${a}`).classList.add("active");
  document
    .querySelectorAll(".tab")
    .forEach((a) => a.classList.remove("active"));
}

document.querySelectorAll(".tab").forEach((e) => {
  e.addEventListener("click", function () {
    const tabId = this.getAttribute("data-tab");
    changeTab(tabId);
    this.classList.add("active");
  });
});

BindEvent();

function BindEvent() {
  const accordions = document.querySelectorAll(".accordian");

  accordions.forEach((acc) => {
    acc.addEventListener("click", function (e) {
      e.preventDefault();

      const parentWrapper = this.closest(".accordiancover");

      const isActive = parentWrapper.classList.contains("active");

      document.querySelectorAll(".accordiancover").forEach((wrapper) => {
        wrapper.classList.remove("active");
        const btn = wrapper.querySelector(".accordian");
        if (btn) btn.setAttribute("aria-expanded", "false");
      });

      if (!isActive) {
        parentWrapper.classList.add("active");
        this.setAttribute("aria-expanded", "true");
      }
    });
  });
}
